import uuidv4 from 'uuid/v4';
import download from 'downloadjs';
import {
  take,
  put,
  select,
  takeLatest,
  race,
  all,
  call,
  fork,
} from 'redux-saga/effects';
import _ from 'lodash';
import HomePagePopUpRegistry from '../../../registries/HomePagePopUpRegistry';
import { BANNER_TO_SHOW } from '../../../actions/appActions';
import { FRAME_APP_MOUNTED } from '../../../actions/frameActions';
import { getModals, getCurrentPath } from '../selectors/selector';
import { showModal, DEEPLINK_MODAL_POPUP } from '../actions';
import { deepLinkFormat } from '../../../utils/WebUtils';
import { getLanguage } from '../../../selectors/userSelectors';

function* componentMounted(): any {
  return;
}

function* init(): any {
  const modals = yield select(getModals);
  const keys = Object.keys(modals);
  keys.forEach((key) => {
    const modal = modals[key];
    const journeyName = modal.query.journeyName;
    const journeyOrder = modal.query.journeyOrder;
    if (journeyName && journeyOrder != undefined) {
      HomePagePopUpRegistry.register(journeyName, journeyOrder);
      console.log(
        `Display banner Register ${journeyName} with order ${journeyOrder}`,
      );
      const isFetchDataRequired = modal.query.isFetchDataRequired;
      if (!isFetchDataRequired) {
        HomePagePopUpRegistry.setFetchDataCompleted(journeyName, true);
        console.log(`Display banner setFetchDataCompleted ${journeyName}`);
      } else {
        HomePagePopUpRegistry.setFetchDataCompleted(journeyName);
      }
    }
  });
}
function* waitAndDisplayBanner(): any {
  const modals = yield select(getModals);
  const keys = Object.keys(modals);
  while (true) {
    yield take(BANNER_TO_SHOW);
    var i;
    for (i = 0; i < keys.length; i++) {
      const key = keys[i];
      const modal = modals[key];
      const journeyName = modal.query.journeyName;
      const journeyOrder = modal.query.journeyOrder;
      const isShowPopup = HomePagePopUpRegistry.getIsDisplay(journeyName);
      const pathname = yield select(getCurrentPath);
      if (
        pathname.endsWith('/home') &&
        isShowPopup &&
        journeyName &&
        journeyOrder != undefined
      ) {
        // Your own action to show popup
        yield put(showModal(deepLinkFormat(modal, getLanguage()).query));
      }
    }
  }
}

function* deeplinkModalPopup(action: any): any {
  const { payload } = action;
  const templateId = payload.templateId;
  console.log(`deeplinkModalPopup with templateId: ${templateId}`);
  const modals = yield select(getModals);
  const modal = modals[templateId];
  if (modal) {
    yield put(showModal(deepLinkFormat(modal, getLanguage()).query));
  }
}

function* modalSaga() {
  yield takeLatest(DEEPLINK_MODAL_POPUP, deeplinkModalPopup);
  yield take(FRAME_APP_MOUNTED);
  yield fork(init);
  yield fork(waitAndDisplayBanner);
}

export default modalSaga;
